module.exports = __webpack_public_path__ + "img/JP-COVER.401367d0.png";